var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",attrs:{"flex":"cross:center"}},[_c('img',{attrs:{"src":require("@/assets/imgs/icon/crumbs-locaition.png")}}),_vm._v("当前位置："),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }